/**
 * This constants are used in the calculator-view.
 */
export const SelectorTypes = {
    financialProducts: 'Financial products',
    productDurations: 'Product durations',
    downPaymentPercentage: 'DownPayment percentages',
};
export const TitleMethods = {
    getTheTotalHitch: 'getTheTotalHitch',
    productDurationPaymentsToArray: 'productDurationPaymentsToArray',
};

/**
 * This constants are used to indicated the specific name of the
 * durations-selector and the percentage-selector.
 */
export const durationsSelector = 'durations';
export const percentageSelector = 'percentages';
